import { render, staticRenderFns } from "./editLiveClass.vue?vue&type=template&id=9a574f0a"
import script from "./editLiveClass.vue?vue&type=script&lang=js"
export * from "./editLiveClass.vue?vue&type=script&lang=js"
import style0 from "./editLiveClass.vue?vue&type=style&index=0&id=9a574f0a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports